export default __webpack_public_path__ + "static/media/korean-elec.d79f6d92.jpg";